import React from 'react';
import { Link } from 'react-router-dom';
import productsData from '../data/products';

function ProductSidebar({ activeCategory }) {

    const categories = [];
    const map = new Map();

    for (const item of productsData) {
        if (!map.has(item.category)) {
            map.set(item.category, true);
            categories.push(item.category);
        }
    }

    // ✅ SLUG FUNCTION (MOST IMPORTANT)
    const slugify = (text) =>
        text.toLowerCase().replace(/\s+/g, '-');

    const formatCategory = (cat) => {
        if (!cat) return '';
        return cat
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className="service-details-sidebar marginTop"  >
            <div className="single-service-sidebar">
                {/* <div className="sidebar-title">
                    <h3>Product Categories</h3>
                </div> */}
                <ul>
                    {categories.map((cat, index) => {
                        const slug = slugify(cat);

                        const isActive = slug === activeCategory;

                        return (
                            <li key={index}>
                                <Link
                                    to={`/products/${slug}#product-category-title`}
                                    className={isActive ? 'active-category' : ''}
                                    style={{ borderRadius: '4px' }}
                                >
                                    {formatCategory(cat)}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default ProductSidebar;